/* ============================================================
   Supply module — mock data
   ------------------------------------------------------------
   Ported from the Caliper "CureBay Operator Console" UI kit.
   This is dummy data used to populate the Supply screens until
   the real APIs are wired. The screens never import this file
   directly — they go through `Services/supplyService.js`, which
   is the single swap point for live endpoints.
   ============================================================ */

export const CB_WAREHOUSES = [
  { id: "BBSR", name: "Bhubaneswar (Main)", region: "Odisha" },
  { id: "BLS", name: "Balasore Hub", region: "Odisha" },
  { id: "CTC", name: "Cuttack", region: "Odisha" },
];

export const CB_SEGMENTS = [
  { id: "che", label: "CHE/Engage", desc: "Community Health Engagement — via eClinics" },
  { id: "b2c", label: "B2C", desc: "Direct consumer" },
  { id: "eyewear", label: "Eyewear", desc: "Frames + lenses" },
];

export const CB_ECLINICS = [
  { id: "EC-001", name: "e-Clinic Bamanala", addr: "Bamanala, Bhadrak, OD 756100" },
  { id: "EC-002", name: "e-Clinic Baliapal", addr: "Baliapal, Balasore, OD 756026" },
  { id: "EC-003", name: "e-Clinic Khariar", addr: "Khariar, Nuapada, OD 766107" },
  { id: "EC-004", name: "e-Clinic Balugaon", addr: "Balugaon, Khordha, OD 752030" },
];

export const CB_PATIENTS = [
  { id: "NTGHA2043p", name: "Nepolian Ghosh", salutation: "Mr.", mobile: "7852911502", address: "Baliapal Baliapal Balasore OD 756026" },
  { id: "DgYhD3624p", name: "Dare Devil", salutation: "Mr.", mobile: "6205903624", address: "Balugaon 1 Balugaon Bhubaneswar OD 752030" },
  { id: "SBoAo1704p", name: "Sudipta Panda", salutation: "Mr.", mobile: "9777081704", address: "Ankjdfkjui Ankjdfkjui Bhubaneswar OD 751002" },
  { id: "SARA20015", name: "Sabya Mohapatra", salutation: "Mr.", mobile: "7008645527", address: "9999, Sachivalaya Marg, Vani Vihar, Bhubaneswar OD 751004" },
  { id: "LAT1988", name: "Lavanya T", salutation: "Mrs.", mobile: "9626016046", address: "No 15, Saroj Homes, Jaydev Vihar, Bhubaneswar OD 751013" },
  { id: "BXeVF6455p", name: "Bala", salutation: "Mr.", mobile: "8807926455", address: "Kanchipuram, Tamil Nadu 631502" },
  { id: "AFhmN2476p", name: "Arun Test", salutation: "Mr.", mobile: "9751012416", address: "Coimbatore, Tamil Nadu 641018" },
];

/* Orders — only the fields the Supply screens need (allocation queue). */
export const CB_ORDERS = [
  /* Large stress-test order — exercises workspace scrolling with many lines. */
  { id: "ALLOC-TEST", code: "MED-ALLOC-TEST", segment: "che", status: "received", date: "2026-05-21 09:00", patient: "SARA20015", eclinic: "EC-001", amount: 4860.0, slaHours: 48,
    rx: { status: "verified", refId: "RX-TEST34", uploadedAt: "2026-05-21 08:50", doctor: "Dr. QA Tester · MD", clinic: "Bamanala eClinic", pages: 2, verifiedBy: "qa@curebay.in", verifiedAt: "2026-05-21 08:55" } },
  { id: "1779290386221", code: "MED20260514103200", segment: "che", status: "received", date: "2026-05-20 20:49", patient: "NTGHA2043p", eclinic: "EC-002", amount: 18.0, slaHours: 48,
    rx: { status: "pending", refId: "RX-9201", uploadedAt: "2026-05-20 20:42", doctor: "Dr. R. Mishra · MD", clinic: "Bamanala eClinic", pages: 1 } },
  { id: "129392", code: "MED20260414135500", segment: "che", status: "received", date: "2026-04-14 13:55", patient: "DgYhD3624p", eclinic: "EC-004", amount: 69.52, slaHours: 48,
    rx: { status: "verified", refId: "RX-9182", uploadedAt: "2026-04-14 13:42", doctor: "Dr. S. Patnaik · MBBS", clinic: "Balugaon eClinic", pages: 2, verifiedBy: "priya@curebay.in", verifiedAt: "2026-04-14 13:50" } },
  { id: "129401", code: "MED20260415120300", segment: "che", status: "received", date: "2026-04-15 12:03", patient: "SBoAo1704p", eclinic: "EC-004", amount: 51.0, slaHours: 48,
    rx: { status: "queried", refId: "RX-9185", uploadedAt: "2026-04-15 11:50", doctor: "Dr. A. Mohanty · BHMS", clinic: "Balugaon eClinic", pages: 1, query: "Strength unclear on line 2 — awaiting clarification from clinic" } },
  { id: "999195147", code: "-", segment: "b2c", status: "received", date: "2026-04-16 07:21", patient: "LAT1988", amount: 25.52,
    rx: { status: "verified", refId: "RX-9190", uploadedAt: "2026-04-16 07:10", doctor: "Dr. P. Sahoo · MBBS", clinic: "—", pages: 1, verifiedBy: "kavya@curebay.in", verifiedAt: "2026-04-16 07:15" } },
];

/* Medicine master — used by inventory, GRN, billing. */
export const CB_MEDICINES = [
  { id: "MED-0001", sku: "PCM-500-T10", name: "Paracetamol 500 mg", pack: "Strip 10", schedule: "OTC", mrp: 12.5, gst: 12, hsn: "3004", manuf: "Cipla" },
  { id: "MED-0002", sku: "AMOX-250-C20", name: "Amoxicillin 250 mg", pack: "Strip 20", schedule: "H", mrp: 44.0, gst: 12, hsn: "3004", manuf: "Sun Pharma" },
  { id: "MED-0003", sku: "RNT-150-T15", name: "Ranitidine 150 mg", pack: "Strip 15", schedule: "H", mrp: 28.0, gst: 12, hsn: "3004", manuf: "Zydus" },
  { id: "MED-0004", sku: "CTZ-10-T10", name: "Cetirizine 10 mg", pack: "Strip 10", schedule: "OTC", mrp: 31.5, gst: 12, hsn: "3004", manuf: "Cipla" },
  { id: "MED-0005", sku: "AZT-500-T6", name: "Azithromycin 500 mg", pack: "Strip 6", schedule: "H", mrp: 114.0, gst: 12, hsn: "3004", manuf: "Lupin" },
  { id: "MED-0006", sku: "PNT-40-T15", name: "Pantoprazole 40 mg", pack: "Strip 15", schedule: "H", mrp: 52.0, gst: 12, hsn: "3004", manuf: "Alkem" },
  { id: "MED-0007", sku: "MET-500-T10", name: "Metformin 500 mg", pack: "Strip 10", schedule: "H", mrp: 28.0, gst: 12, hsn: "3004", manuf: "USV" },
  { id: "MED-0008", sku: "ATR-10-T10", name: "Atorvastatin 10 mg", pack: "Strip 10", schedule: "H", mrp: 41.0, gst: 12, hsn: "3004", manuf: "Sun Pharma" },
  { id: "MED-0009", sku: "DXM-2-INJ", name: "Dexamethasone 2 mg", pack: "Inj 2 ml", schedule: "H1", mrp: 9.5, gst: 12, hsn: "3003", manuf: "Wockhardt" },
  { id: "MED-0010", sku: "INS-100-VIAL", name: "Insulin Reg 100 IU", pack: "Vial 10 ml", schedule: "H1", mrp: 480.0, gst: 5, hsn: "3004", manuf: "Novo Nordisk" },
];

export const CB_SUPPLIERS = [
  { id: "SUP-001", name: "MediCorp Distributors", gstin: "21AAACM1234N1ZF", terms: "Net 30", credit: 250000, outstanding: 4199135.63 },
  { id: "SUP-002", name: "Bharat Pharma Wholesale", gstin: "21AABCB5678P2Z3", terms: "Net 15", credit: 100000, outstanding: 86420.0 },
  { id: "SUP-003", name: "Apollo Healthcare Supply", gstin: "21AABCA9012Q1ZY", terms: "Net 45", credit: 500000, outstanding: 312540.5 },
  { id: "SUP-004", name: "Generic Drug House", gstin: "21AAACG3456R1Z8", terms: "Net 30", credit: 175000, outstanding: 0 },
  { id: "SUP-005", name: "Eastern Surgicals Pvt Ltd", gstin: "21AAFCE7788M1ZL", terms: "Net 30", credit: 60000, outstanding: 14820.75 },
];

/* Purchase / GRN reference lists — mirror the eShopAid Direct Purchase form. */
export const CB_GRN_SERIES = ["PD - CREDIT PURCHASE", "PD - CASH PURCHASE", "PD - IMPORT PURCHASE"];
export const CB_PAYMENT_MODES = ["Credit", "Cash", "Card", "UPI", "Bank transfer"];
/* CB_LOCATIONS (a dummy GODOWN / RACK-A list) is gone — storage locations are
   real records now, per warehouse: see Supply/Racks and v1/racks. */

/* Inventory lots — one row per (warehouse, medicine, batch, purchase price). */
export const CB_LOTS = [
  { id: 4823, wh: "BBSR", medId: "MED-0001", batch: "B204", exp: "2026-07-15", purchase: 10.0, mrp: 12.5, sale: 11.2, qtyR: 200, qtyA: 200, grn: "GRN-1042", date: "2026-04-12" },
  { id: 4901, wh: "BBSR", medId: "MED-0001", batch: "B204", exp: "2026-07-15", purchase: 11.5, mrp: 12.5, sale: 11.2, qtyR: 50, qtyA: 50, grn: "GRN-1067", date: "2026-04-28" },
  { id: 5012, wh: "BBSR", medId: "MED-0001", batch: "B305", exp: "2027-01-20", purchase: 11.5, mrp: 12.5, sale: 11.2, qtyR: 320, qtyA: 320, grn: "GRN-1081", date: "2026-05-04" },
  { id: 5188, wh: "BLS", medId: "MED-0002", batch: "A0091", exp: "2026-08-14", purchase: 39.0, mrp: 44.0, sale: 41.5, qtyR: 400, qtyA: 340, grn: "GRN-1099", date: "2026-03-30" },
  { id: 5240, wh: "BBSR", medId: "MED-0003", batch: "R7723", exp: "2026-05-04", purchase: 25.0, mrp: 28.0, sale: 26.5, qtyR: 120, qtyA: 96, grn: "GRN-1110", date: "2026-02-21", flag: "expired" },
  { id: 5290, wh: "BBSR", medId: "MED-0004", batch: "C5512", exp: "2027-04-15", purchase: 28.0, mrp: 31.5, sale: 30.0, qtyR: 2100, qtyA: 2108, grn: "GRN-1132", date: "2026-05-12" },
  { id: 5320, wh: "CTC", medId: "MED-0005", batch: "AZ-44", exp: "2026-09-22", purchase: 96.0, mrp: 114.0, sale: 108.0, qtyR: 180, qtyA: 142, grn: "GRN-1148", date: "2026-04-02" },
  { id: 5388, wh: "BLS", medId: "MED-0006", batch: "P-AL19", exp: "2026-09-08", purchase: 42.5, mrp: 52.0, sale: 48.5, qtyR: 240, qtyA: 240, grn: "GRN-1163", date: "2026-05-08" },
  { id: 5402, wh: "BBSR", medId: "MED-0007", batch: "MF-22B", exp: "2026-07-30", purchase: 23.0, mrp: 28.0, sale: 26.0, qtyR: 600, qtyA: 512, grn: "GRN-1170", date: "2026-04-14" },
  { id: 5444, wh: "BBSR", medId: "MED-0008", batch: "AT-091", exp: "2026-11-19", purchase: 33.0, mrp: 41.0, sale: 38.5, qtyR: 300, qtyA: 300, grn: "GRN-1182", date: "2026-05-02" },
  { id: 5501, wh: "BBSR", medId: "MED-0009", batch: "DX-INJ", exp: "2027-02-10", purchase: 7.5, mrp: 9.5, sale: 8.75, qtyR: 480, qtyA: 412, grn: "GRN-1199", date: "2026-04-25" },
  { id: 5544, wh: "BLS", medId: "MED-0010", batch: "INS-7A", exp: "2026-12-30", purchase: 380, mrp: 480, sale: 445, qtyR: 60, qtyA: 24, grn: "GRN-1211", date: "2026-04-08", flag: "low" },
];

/* Stock movements / ledger. */
export const CB_MOVEMENTS = [
  { ts: "2026-05-14 14:32:11", type: "OUT", lot: 4823, qty: -100, ref: "999195134", who: "kavya@curebay.in", note: "FIFO pick" },
  { ts: "2026-05-14 13:14:02", type: "IN", lot: 5188, qty: 400, ref: "GRN-1099", who: "priya@curebay.in", note: "GRN posted" },
  { ts: "2026-05-14 11:48:30", type: "IN", lot: 5402, qty: 600, ref: "GRN-1170", who: "priya@curebay.in", note: "GRN posted" },
  { ts: "2026-05-14 10:22:15", type: "EXPIRED", lot: 5240, qty: -24, ref: "EXP-AUTO", who: "system", note: "Auto-flag · exp 2026-05-04" },
  { ts: "2026-05-14 09:51:00", type: "ADJUST", lot: 5320, qty: -2, ref: "ADJ-0091", who: "priya@curebay.in", note: "Damaged seal" },
];

/* GRN — Goods Receipt Notes. Lifecycle: draft -> receiving -> posted (or cancelled). */
export const CB_GRNS = [
  { id: "GRN-1182", supplier: "SUP-001", supplierInv: "MC-INV-44182", date: "2026-05-12", wh: "BBSR", status: "posted", items: 3, units: 1240, value: 38440, postedBy: "priya@curebay.in" },
  { id: "GRN-1183", supplier: "SUP-003", supplierInv: "AP-99431", date: "2026-05-13", wh: "BBSR", status: "posted", items: 8, units: 6820, value: 114220, postedBy: "priya@curebay.in" },
  { id: "GRN-1184", supplier: "SUP-002", supplierInv: "BP-22091", date: "2026-05-14", wh: "BLS", status: "receiving", items: 5, units: 2400, value: 48500, postedBy: null },
  { id: "GRN-1185", supplier: "SUP-004", supplierInv: "GDH-7188", date: "2026-05-14", wh: "BBSR", status: "receiving", items: 6, units: 3120, value: 62800, postedBy: null, slaWarn: true },
  { id: "GRN-1186", supplier: "SUP-001", supplierInv: "MC-44199", date: "2026-05-14", wh: "CTC", status: "draft", items: 4, units: 1800, value: 24900, postedBy: null },
  { id: "GRN-1181", supplier: "SUP-002", supplierInv: "BP-22088", date: "2026-05-11", wh: "BBSR", status: "posted", items: 4, units: 2080, value: 41080, postedBy: "kavya@curebay.in" },
  { id: "GRN-1180", supplier: "SUP-003", supplierInv: "AP-99428", date: "2026-05-10", wh: "BBSR", status: "cancelled", items: 0, units: 0, value: 0, postedBy: null, note: "PO mismatch" },
];

/* One GRN's line items, used in the GRN detail panel. */
export const CB_GRN_LINES = [
  { medId: "MED-0001", batch: "B305", exp: "2027-01-20", mrp: 12.5, ordered: 400, received: 400, short: 0, purchase: 11.5 },
  { medId: "MED-0008", batch: "AT-091", exp: "2026-11-19", mrp: 41.0, ordered: 300, received: 300, short: 0, purchase: 33.0 },
  { medId: "MED-0006", batch: "P-AL19", exp: "2026-09-08", mrp: 52.0, ordered: 300, received: 240, short: 60, purchase: 42.5 },
];

/* Purchase Orders — the document raised to a supplier *before* goods arrive
   (a GRN later receives against it). Phase 1 is standalone:
   draft -> approved -> sent (or cancelled). Shapes mirror the GRN row/line so
   the service mappers stay near-clones. The `received*`/`open*` fields are
   Phase 2 (lifecycle) — present at 0 so the UI can light up later untouched. */
export const CB_PAYMENT_TERMS = ["Net 15", "Net 30", "Net 45", "Advance", "On delivery"];

export const CB_PURCHASE_ORDERS = [
  { id: "PO-2026-00042", supplier: "SUP-001", date: "2026-06-15", expectedDate: "2026-06-24", wh: "BBSR", warehouseId: "BBSR", paymentTerms: "Net 30", status: "sent", items: 3, orderedUnits: 1240, value: 42668.4, totalAmount: 38440, discountAmount: 384.4, gstAmount: 4612.8, createdBy: "priya@curebay.in", receivedUnits: 0 },
  { id: "PO-2026-00043", supplier: "SUP-003", date: "2026-06-16", expectedDate: "2026-06-26", wh: "BBSR", warehouseId: "BBSR", paymentTerms: "Net 45", status: "approved", items: 5, orderedUnits: 3200, value: 121540, totalAmount: 110200, discountAmount: 1102, gstAmount: 12442, createdBy: "priya@curebay.in", receivedUnits: 0 },
  { id: "PO-2026-00044", supplier: "SUP-002", date: "2026-06-16", expectedDate: "2026-06-23", wh: "BLS", warehouseId: "BLS", paymentTerms: "Net 15", status: "draft", items: 2, orderedUnits: 600, value: 27200, totalAmount: 24500, discountAmount: 0, gstAmount: 2700, createdBy: "kavya@curebay.in", receivedUnits: 0 },
  { id: "PO-2026-00045", supplier: "SUP-004", date: "2026-06-17", expectedDate: "2026-06-27", wh: "BBSR", warehouseId: "BBSR", paymentTerms: "Net 30", status: "sent", items: 4, orderedUnits: 1800, value: 31200, totalAmount: 28100, discountAmount: 281, gstAmount: 3381, createdBy: "priya@curebay.in", receivedUnits: 0 },
  { id: "PO-2026-00041", supplier: "SUP-005", date: "2026-06-12", expectedDate: "2026-06-20", wh: "CTC", warehouseId: "CTC", paymentTerms: "On delivery", status: "cancelled", items: 0, orderedUnits: 0, value: 0, totalAmount: 0, discountAmount: 0, gstAmount: 0, createdBy: "kavya@curebay.in", note: "Duplicate of PO-2026-00040", receivedUnits: 0 },
];

/* One PO's line items, used in the PO detail panel + edit drawer. `received`
   and `openQty` are Phase 2 (default received 0, openQty == ordered). */
export const CB_PO_LINES = {
  "PO-2026-00042": [
    { medId: "MED-0001", medicineName: "Paracetamol 500 mg", ordered: 400, purchase: 11.5, mrp: 12.5, sellingPrice: 12.0, discountPct: 1.0, taxPct: 12, received: 0, openQty: 400 },
    { medId: "MED-0008", medicineName: "Atorvastatin 10 mg", ordered: 300, purchase: 33.0, mrp: 41.0, sellingPrice: 38.5, discountPct: 1.0, taxPct: 12, received: 0, openQty: 300 },
    { medId: "MED-0006", medicineName: "Pantoprazole 40 mg", ordered: 540, purchase: 42.5, mrp: 52.0, sellingPrice: 48.5, discountPct: 1.0, taxPct: 12, received: 0, openQty: 540 },
  ],
};

/* Pack queue — billed orders awaiting physical pack. */
export const CB_PACK_QUEUE = [
  { orderId: "MED20260514103200", invoiceId: "INV-2026-04430", patientId: "NTGHA2043p", segment: "che", eclinic: "EC-002",
    billedAt: "2026-05-14 11:02", billedBy: "priya@curebay.in", courier: "Delhivery", awb: null, address: "home",
    lots: [
      { medId: "MED-0001", lotId: 4823, batch: "B204", exp: "2026-07-15", qty: 30, bin: "A-12-03" },
      { medId: "MED-0004", lotId: 5290, batch: "C5512", exp: "2027-04-15", qty: 20, bin: "A-14-07" },
      { medId: "MED-0006", lotId: 5388, batch: "P-AL19", exp: "2026-09-08", qty: 15, bin: "B-04-11" },
    ] },
  { orderId: "MED20260514111200", invoiceId: "INV-2026-04431", patientId: "DgYhD3624p", segment: "che", eclinic: "EC-004",
    billedAt: "2026-05-14 11:38", billedBy: "priya@curebay.in", courier: "BlueDart", awb: null, address: "home",
    lots: [
      { medId: "MED-0007", lotId: 5402, batch: "MF-22B", exp: "2026-07-30", qty: 60, bin: "B-08-02" },
      { medId: "MED-0008", lotId: 5444, batch: "AT-091", exp: "2026-11-19", qty: 30, bin: "B-08-04" },
    ] },
  { orderId: "999195139", invoiceId: "INV-2026-04425", patientId: "SARA20015", segment: "b2c",
    billedAt: "2026-05-14 12:51", billedBy: "kavya@curebay.in", courier: "DTDC", awb: null, address: "home",
    lots: [
      { medId: "MED-0002", lotId: 5188, batch: "A0091", exp: "2026-08-14", qty: 10, bin: "C-02-19" },
    ] },
];

/* What each order contains (medicine + qty). Keyed by orderId. */
export const CB_ORDER_LINES = {
  /* 34-line stress test — every medicine, repeated, to force workspace scroll. */
  "ALLOC-TEST": [
    { medId: "MED-0001", qty: 30 },
    { medId: "MED-0002", qty: 20 },
    { medId: "MED-0003", qty: 15 },
    { medId: "MED-0004", qty: 40 },
    { medId: "MED-0005", qty: 12 },
    { medId: "MED-0006", qty: 25 },
    { medId: "MED-0007", qty: 60 },
    { medId: "MED-0008", qty: 35 },
    { medId: "MED-0009", qty: 18 },
    { medId: "MED-0010", qty: 10 },
  ],
  129392: [
    { medId: "MED-0001", qty: 30 },
    { medId: "MED-0004", qty: 20 },
  ],
  129401: [
    { medId: "MED-0007", qty: 60 },
    { medId: "MED-0008", qty: 30 },
  ],
  999195147: [{ medId: "MED-0003", qty: 10 }],
};

/* Billing queue — confirmed + allocated orders awaiting an invoice. */
export const CB_BILLING_QUEUE = [
  { orderId: "MED20260514103200", patientId: "NTGHA2043p", segment: "che",
    confirmedAt: "2026-05-14 10:32", allocatedAt: "2026-05-14 10:34", allocatedBy: "priya@curebay.in",
    allocations: [
      { medId: "MED-0001", lotId: 4823, batch: "B204", exp: "2026-07-15", qty: 30, rate: 11.2, mrp: 12.5 },
      { medId: "MED-0004", lotId: 5290, batch: "C5512", exp: "2027-04-15", qty: 20, rate: 30.0, mrp: 31.5 },
      { medId: "MED-0006", lotId: 5388, batch: "P-AL19", exp: "2026-09-08", qty: 15, rate: 48.5, mrp: 52.0 },
    ],
    eclinic: "EC-002", address: null, prescription: "RX-9182" },
  { orderId: "MED20260514111200", patientId: "DgYhD3624p", segment: "che",
    confirmedAt: "2026-05-14 11:12", allocatedAt: "2026-05-14 11:14", allocatedBy: "priya@curebay.in",
    allocations: [
      { medId: "MED-0007", lotId: 5402, batch: "MF-22B", exp: "2026-07-30", qty: 60, rate: 26.0, mrp: 28.0 },
      { medId: "MED-0008", lotId: 5444, batch: "AT-091", exp: "2026-11-19", qty: 30, rate: 38.5, mrp: 41.0 },
    ],
    eclinic: "EC-004", address: null, prescription: "RX-9183" },
  { orderId: "999195139", patientId: "SARA20015", segment: "b2c",
    confirmedAt: "2026-05-14 12:35", allocatedAt: "2026-05-14 12:38", allocatedBy: "kavya@curebay.in",
    allocations: [
      { medId: "MED-0002", lotId: 5188, batch: "A0091", exp: "2026-08-14", qty: 10, rate: 41.5, mrp: 44.0 },
    ],
    prescription: "RX-9185", address: "home" },
];

/* Invoices. Lifecycle: draft -> issued -> partial / paid / overdue. */
export const CB_INVOICES = [
  { id: "INV-2026-04425", customerName: "Sabya Mohapatra", kind: "b2c", issued: "2026-05-14", due: "2026-05-14", amount: 1842, paid: 1842, status: "paid" },
  { id: "INV-2026-04426", customerName: "Lavanya T", kind: "b2c", issued: "2026-05-14", due: "2026-05-14", amount: 915, paid: 915, status: "paid" },
  { id: "INV-2026-04427", customerName: "Bala", kind: "eyewear", issued: "2026-05-14", due: "2026-05-14", amount: 2199, paid: 2199, status: "paid" },
  { id: "INV-2026-04428", customerName: "Nepolian Ghosh", kind: "che", issued: "2026-05-14", due: "2026-05-21", amount: 1249, paid: 0, status: "draft" },
  { id: "INV-2026-04430", customerName: "Dare Devil", kind: "che", issued: "2026-05-13", due: "2026-05-20", amount: 2180, paid: 0, status: "issued" },
  { id: "INV-2026-04431", customerName: "Sudipta Panda", kind: "che", issued: "2026-04-30", due: "2026-05-07", amount: 540, paid: 100, status: "partial" },
  { id: "INV-2026-04432", customerName: "Arun Test", kind: "eyewear", issued: "2026-05-14", due: "2026-05-14", amount: 2199, paid: 2199, status: "paid" },
  { id: "INV-2026-04433", customerName: "Nepolian Ghosh", kind: "che", issued: "2026-04-12", due: "2026-04-19", amount: 3120, paid: 0, status: "overdue" },
];

/* Line items shown on an issued invoice's detail panel. */
export const CB_INVOICE_LINES = [
  { medId: "MED-0001", qty: 240, rate: 11.2, gst: 12 },
  { medId: "MED-0004", qty: 50, rate: 30.0, gst: 12 },
  { medId: "MED-0006", qty: 30, rate: 48.5, gst: 12 },
];

/* ============ HELPERS ============ */

export const cbFmtINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const cbFmtNum = (n) => Number(n || 0).toLocaleString("en-IN");

/* Clock time out of an ISO timestamp ("2026-07-27T12:10:35.394702" -> "12:10:35").
   Purchase / PO rows carry a date-only invoiceDate|poDate, so the time shown
   next to them comes from `createdAt` — the moment the record was entered.
   Returns "" for a date-only value, so callers can simply omit it. */
export const cbFmtTime = (iso) => {
  const m = String(iso || "").match(/T(\d{2}):(\d{2})(?::(\d{2}))?/);
  return m ? `${m[1]}:${m[2]}:${m[3] || "00"}` : "";
};

/* "2026-07-27T12:10:35" -> "2026-07-27 12:10:35" for tooltips / exports. */
export const cbFmtDateTime = (iso) => {
  const s = String(iso || "");
  if (!s) return "";
  const t = cbFmtTime(s);
  return t ? `${s.slice(0, 10)} ${t}` : s.slice(0, 10);
};

export const cbStatusVariant = (s) =>
  ({
    enquiry: "ink",
    received: "ink",
    confirmed: "amber",
    shipment_received: "transfer",
    packed: "green",
    cancelled: "red",
    draft: "neutral",
    receiving: "amber",
    posted: "green",
    issued: "ink",
    partial: "amber",
    paid: "green",
    overdue: "red",
    /* Purchase Order lifecycle. Phase 1: draft -> approved -> sent (or
       cancelled). partially_received / closed are reserved for the Phase 2
       receive-against-PO flow (see SUPPLY_API_SPEC.md §2A). */
    approved: "ink",
    sent: "transfer",
    partially_received: "amber",
    closed: "green",
  }[s] || "neutral");

/* Expiry bucket relative to a reference "today". */
export const cbExpiryStatus = (expStr, today = new Date("2026-05-14")) => {
  const exp = new Date(expStr);
  const days = Math.round((exp - today) / 86400000);
  if (days < 0) return { status: "expired", days, label: "Expired" };
  if (days < 90) return { status: "soon", days, label: `${days}d` };
  return { status: "fresh", days, label: "Fresh" };
};
